import * as actionTypes from "../actions/actionTypes";

const initialState = {
  user: null,
  widgetInfo: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER:
      return {
        ...state,
        user: action.user,
      };
    case actionTypes.SET_WIDGET_INFO:
      return {
        ...state,
        widgetInfo: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
